// extracted by mini-css-extract-plugin
module.exports = {"root":"InfoRow_root__3W2uK","left":"InfoRow_left__4hO2O"};